import { INBOX_TAG_NAME_MAX_LENGTH, type InboxTag } from '@sbc/domain-models/gateway';

const MAX_SUGGESTIONS = 6;

export interface TagPicks {
  suggestions: InboxTag[];
  newName: string | null;
  alreadyApplied: boolean;
}

export function tagPicks(
  all: readonly InboxTag[],
  applied: readonly InboxTag[],
  typed: string,
): TagPicks {
  const name = typed.trim();
  const query = name.toLowerCase();
  const appliedIds = new Set(applied.map((tag) => tag.id));
  const suggestions = all
    .filter((tag) => !appliedIds.has(tag.id) && tag.name.toLowerCase().includes(query))
    .slice(0, MAX_SUGGESTIONS);
  const named = (tag: InboxTag) => tag.name.toLowerCase() === query;
  const known = all.some(named) || applied.some(named);
  const fits = name.length > 0 && name.length <= INBOX_TAG_NAME_MAX_LENGTH;
  return {
    suggestions,
    newName: fits && !known ? name : null,
    alreadyApplied: applied.some(named),
  };
}

export function tagToAdd(picks: TagPicks, typed: string): string | null {
  if (picks.alreadyApplied) {
    return null;
  }
  const query = typed.trim().toLowerCase();
  const exact = picks.suggestions.find((tag) => tag.name.toLowerCase() === query);
  return exact?.name ?? picks.suggestions[0]?.name ?? picks.newName;
}

export function visibleTags(
  tags: readonly InboxTag[],
  max: number,
): { shown: InboxTag[]; more: number } {
  return { shown: tags.slice(0, max), more: Math.max(0, tags.length - max) };
}
